import React from 'react';
import type { BombiixIconProps } from './types';

/**
 * Bombiix Invite Supplier icon — user silhouette + add badge.
 * Uses `currentColor` so the parent `.bombiix-icon-container` modifier drives the tint.
 */
const InviteSupplierIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...rest}
  >
    <path
      d="M12.166 6.00098C12.166 4.80447 11.1965 3.83416 10 3.83398C8.80338 3.83398 7.83301 4.80436 7.83301 6.00098C7.83318 7.19744 8.80349 8.16699 10 8.16699C11.1964 8.16682 12.1658 7.19734 12.166 6.00098ZM13.166 6.00098C13.1658 7.74962 11.7486 9.16682 10 9.16699C8.25121 9.16699 6.83318 7.74973 6.83301 6.00098C6.83301 4.25207 8.2511 2.83398 10 2.83398C11.7488 2.83416 13.166 4.25218 13.166 6.00098Z"
      fill="currentColor"
    />
    <path
      d="M4.16708 13.666C4.16708 12.5767 4.94715 11.6929 5.98446 11.1094C7.03736 10.5172 8.4579 10.1661 10.0001 10.166C10.7434 10.166 11.4561 10.2473 12.1114 10.3965L12.0001 10.8838L11.8897 11.3721C11.3098 11.24 10.6713 11.166 10.0001 11.166C8.59723 11.1661 7.35192 11.4871 6.4747 11.9805C5.58172 12.4828 5.16708 13.0985 5.16708 13.666C5.16708 14.5378 5.19407 15.0285 5.6495 15.3994C5.89652 15.6006 6.30985 15.7974 7.01669 15.9404C7.72123 16.083 8.68438 16.166 10.0001 16.166C11.8796 16.166 13.0295 15.9957 13.7315 15.7344C14.3987 15.4859 14.6242 15.1722 14.7286 14.8467L15.2052 14.999L15.6808 15.1523C15.4683 15.8144 14.9877 16.334 14.0802 16.6719C13.207 16.9969 11.9121 17.166 10.0001 17.166C8.64973 17.166 7.61278 17.0809 6.81747 16.9199C6.02456 16.7594 5.43723 16.5165 5.01767 16.1748C4.14019 15.46 4.16708 14.4509 4.16708 13.666Z"
      fill="currentColor"
    />
    <path
      d="M16.166 12.667C16.166 11.4705 15.1965 10.5002 14 10.5C12.8034 10.5 11.833 11.4704 11.833 12.667C11.8332 13.8635 12.8035 14.833 14 14.833C15.1964 14.8328 16.1658 13.8634 16.166 12.667ZM17.166 12.667C17.1658 14.4156 15.7486 15.8328 14 15.833C12.2512 15.833 10.8332 14.4157 10.833 12.667C10.833 10.9181 12.2511 9.5 14 9.5C15.7488 9.50018 17.166 10.9182 17.166 12.667Z"
      fill="currentColor"
    />
    <path
      d="M13.5 13.5547V11.7773C13.5 11.5012 13.7239 11.2773 14 11.2773C14.2761 11.2773 14.5 11.5012 14.5 11.7773V13.5547C14.5 13.8308 14.2761 14.0547 14 14.0547C13.7239 14.0547 13.5 13.8308 13.5 13.5547Z"
      fill="currentColor"
    />
    <path
      d="M14.8877 13.166L13.1104 13.166C12.8342 13.166 12.6104 12.9422 12.6104 12.666C12.6104 12.3899 12.8342 12.166 13.1104 12.166L14.8877 12.166C15.1638 12.166 15.3877 12.3899 15.3877 12.666C15.3877 12.9422 15.1638 13.166 14.8877 13.166Z"
      fill="currentColor"
    />
  </svg>
);

export default InviteSupplierIcon;
